import styled from "styled-components";

export const StyledCardDescription = styled.span`
    color: var(--color-grey-800);
    font-size: var(--size-12);
    line-height: 20px;
    font-weight: normal;
`;

export default StyledCardDescription;
